<script setup lang="ts"></script>

<template>
  <div class="flex flex-row items-center justify-start w-full text-body-2 hover:bg-medium-default hover:bg-opacity-10 transition-all duration-150 cursor-pointer select-none p-1 rounded">
    <div class="flex flex-row items-center justify-start w-full text-body-2">
      <slot name="icon" />
      <span class="ml-1">
        <slot />
      </span>
    </div>
  </div>
</template>

<style scoped></style>
